<template>
	<div class="date-picker-months">
		<h5 class="date-picker-months__label">Select a Month</h5>
		<List class="date-picker-months__list" :listItems="months">
			<template v-slot:default="slotProps">
				<ButtonSmall
					class="date-picker-months__item"
					@click="onClickMonth(slotProps.item)"
					:labelText="slotProps.item.monthName"
					:selected="slotProps.item.index === value"
				/>
			</template>
		</List>
	</div>
</template>

<script>
import List from '@/components/shells/list/list.vue';
import ButtonSmall from '@/components/forms/button/button-small.vue';
import dateLocaleMixin from '@/mixins/date-locale-mixin';
import { getMonth } from 'date-fns';

export default {
	name: 'DatePickerMonths',
	mixins: [dateLocaleMixin],
	components: {
		List,
		ButtonSmall
	},
	data() {
		return {
			months: []
		};
	},
	props: {
		value: {
			type: Number,
			default: () => {
				const currentDate = new Date();
				return getMonth(currentDate);
			}
		},
		/**
		 * values narrow, abbreviated, wide
		 */
		nameWidth: {
			type: String,
			default: 'abbreviated'
		}
	},
	created() {
		//function from mixin
		this.months = this.getMonthListItems();
	},
	methods: {
		getMonthListItems() {
			const listItems = [];
			const monthValues = this.getMonthValues(this.nameWidth);

			for (let index = 0; index < monthValues.length; index++) {
				listItems.push({
					index: index,
					monthName: monthValues[index]
				});
			}

			return listItems;
		},
		onClickMonth(month) {
			this.$emit('input', month.index);
			this.$emit('change', month.index);
		}
	}
};
</script>

<style lang="scss" scoped>
.date-picker-months {
	&__label {
		@include heading('md');
		text-align: center;
		margin-bottom: $gutter-xl;
		color: var(--field-fg);
	}

	&__list {
		@include date-picker-list-grid;
	}
}
</style>
